import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import userModule from './modules/user'
import homeModule from './modules/home'
import tabsModule from './modules/tabs'
import commonModule from './modules/common'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    m_user: userModule,
    m_home: homeModule,
    m_tabs: tabsModule,
    m_common: commonModule
  },
  plugins: [
    createPersistedState({
      reducer: state => {
        return {
          m_home: state.m_home,
          m_tabs: {
            isAsideShow: state.m_tabs.isAsideShow,
            // isHeaderShow: state.m_tabs.isHeaderShow,
            headerTabMenu: state.m_tabs.headerTabMenu,
            asideTabMenu: state.m_tabs.asideTabMenu
          },
          m_user: state.m_user,
          // m_common:state.m_common
        }
      }
    })
  ]
})

export default store
